<template lang="pug">
.image-wrapper.column.center(v-if="data" :class="[(fullscreen!==false) && 'fullscreen', (data.length <= 1) && 'single']" @click="fullscreen = false")
  .arrow.icon.previous(v-if="data.length > 1" :class="{inactive: index === 0}" @click.stop.prevent="previous_image")
    font-awesome-icon(icon="chevron-left")
  .arrow.icon.next(v-if="data.length > 1" :class="{inactive: index === data.length - 1}" @click.stop.prevent="next_image")
    font-awesome-icon(icon="chevron-right")
  .content(v-if="fullscreen" @click.stop.prevent="fullscreen = false")
    .image-container
      .delete.row.center( @click.stop.prevent="$emit('delete', data[fullscreen]);fullscreen=false;")
        .icon
          font-awesome-icon(icon="trash")
      img(v-storage="data[index]")
  .scrolling-wrapper.row(v-else)
    .content(v-for="img, idx in data" @click.stop.prevent="fullscreen = true; index=idx;")
      .image-container
        .overlay.column.center(v-if="!fullscreen")
          .icon
            font-awesome-icon(icon="expand")
        img(v-storage="img")
    .placeholder
  .row.center(v-if="data.length > 1") {{index+1}}/{{data.length}}
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      fullscreen: false,
      index: 0,
    }
  },
  watch: {
    fullscreen() {
      this.$emit('fullscreen', this.fullscreen)
    }
  },
  methods: {
    scroll_wrapper() {
      const scrollingWrapper = document.querySelector('.scrolling-wrapper')
      if (!scrollingWrapper) return
      scrollingWrapper.scrollLeft = (this.index * 240)
    },
    next_image() {
      this.index = Math.min(this.data.length - 1, this.index + 1)
      this.scroll_wrapper()
    },
    previous_image() {
      this.index = Math.max(0, this.index - 1)
      this.scroll_wrapper()
    }
  }
}
</script>
<style>
.image-wrapper:not(.fullscreen), .image-wrapper:not(.fullscreen) .image-container img {
  height: 200px;
  min-width: 240px;
  object-fit: contain;
}
.image-wrapper.single:not(.fullscreen), .image-wrapper.single:not(.fullscreen) .image-container img {
  height: inherit;
  min-width: 100%;
}
.image-wrapper, .image-wrapper .content {
  position: relative;
}
.image-wrapper .arrow {
  position: absolute;
  top: calc(50% - 12px);
  width: 36px;
  height: 36px;
  padding: 6px;
  background: var(--background);
  z-index: 100;
  border-radius: 2px;
  border: 2px solid var(--lightgrey);
}
.image-wrapper .arrow.inactive {
  display: none;
  pointer-events: none;
}
.image-wrapper .arrow:hover {
  cursor: pointer;
  border: 2px solid var(--darkgrey);
}
.image-wrapper .arrow.next {
  right: 0;
}
.image-wrapper .arrow.previous {
  left: 0;
}
.image-wrapper.fullscreen .arrow {
  width: 48px;
  height: 48px;

}
.scrolling-wrapper {
  max-width: 100%;
  overflow: hidden;
  scroll-behavior: smooth;
  padding: 0 24px;
}
.scrolling-wrapper .content {
  margin-right: 12px;
}
.scrolling-wrapper .placeholder {
  width: 240px;
  height: 240px;
}
.single .scrolling-wrapper {
  padding: 0;
}
.single .scrolling-wrapper .placeholder {
  display: none;
}
.image-wrapper.fullscreen .arrow.next {
  right: 10%;
}
.image-wrapper.fullscreen .arrow.previous {
  left: 10%;
}
.image-wrapper .delete {
  width: 36px;
  height: 36px;
  padding: 8px;
  border-radius: 50%;
  position: absolute;
  top: -40px;
  right: 8px;
  color: var(--primary);
}
.image-wrapper .delete .icon {
  width: 28px;
  height: 28px;

}
.image-wrapper .delete:hover {
  background: rgba(0,0,0,0.3);
  cursor: pointer;
}
.image-wrapper.fullscreen{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1000;
}
.image-wrapper.fullscreen .image-container, .image-wrapper.fullscreen .image-container img {
  max-width: 720px;
  max-height: 600px;
  position: relative;
}
.image-wrapper .overlay {
  background: rgba(0,0,0,0.3);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.12s ease-in-out;
  cursor: pointer;
}

.image-wrapper .content:hover .overlay {
  opacity: 1;
}
.image-wrapper .overlay .icon {
  color: var(--lightgrey);
  width: 24px;
  height: 24px;
}
.image-wrapper img {
  vertical-align: top;

}
</style>
